import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { getStore } from '@app/react/store/getStore';
import { AppRoute } from '@app/react/AppRoute';
import { MediaContextProvider } from '@app/react/contexts/useMediaContext';
import { useMediaDesktop, useMediaMobile } from '@app/react/common/useMedia';

export const App: FC = () => {
    const { store, persistor } = getStore();
    const isDesktop = useMediaDesktop();
    const isMobiel = useMediaMobile();

    return (
        <MediaContextProvider value={{ desktop: isDesktop, mobile: isMobiel }}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <AppRoute />
                </PersistGate>
            </Provider>
        </MediaContextProvider>
    );
};
